import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang, useRouter, useEffect, useState, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();

    return (
        <div id="delta-pro-ultra-prelaunch-F" className={`delta-pro-ultra-F ${css['delta-pro-ultra-F']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secF_title')}</p>
                    <div className="desc">
                        {t.rich('secF_desc', {
                            a: (text: string) => (
                                <a href={`mailto:${text}`} className="desc-link">
                                    {text}
                                </a>
                            ),
                            s: (text: string) => <p className="space">{text}</p>,
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                            store: (text: string) => (
                                <Link className="link" href={`https://${locale}.ecoflow.com/`}>
                                    {text}
                                </Link>
                            ),
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
